import OrderSuccess from "./OrderSuccess";

export default OrderSuccess;
